<template>
	<div class="page">
		<header>
			<h1>
				Garage
				<br />véhicules
			</h1>
			<h3>
				Intégré à la structure
				<br />du bâtiment
			</h3>
		</header>
		<article>
			<div class="gauche">
				<h2>Sans</h2>
				<div
					:class="garage == 'Non' ? 'selected option' : 'option'"
					id="sans"
					@click="handleGarage('sans', 'Non')"
				>
					<img src="../assets/05-sans.png" />
				</div>
			</div>
			<div class="gauche">
				<h2>1 voiture</h2>
				<div
					:class="garage == 'Oui, 1 véhicule' ? 'selected option' : 'option'"
					id="un"
					@click="handleGarage('un', 'Oui, 1 véhicule')"
				>
					<img src="../assets/05-1voiture.png" />
				</div>
			</div>
			<div class="droite">
				<h2>2 voitures</h2>
				<div
					:class="garage == 'Oui, 2 véhicules' ? 'selected option' : 'option'"
					id="deux"
					@click="handleGarage('deux', 'Oui, 2 véhicules')"
				>
					<img src="../assets/05-2voitures.png" />
				</div>
			</div>
		</article>
		<footer>
			<router-link to="/finition" class="button back">
				<i class="fa fa-angle-left"></i>
			</router-link>
			<router-link v-if="ready || garage.length > 1" to="/carport" class="button medium">
				Carport
				<i class="fa fa-angle-right"></i>
			</router-link>
		</footer>
	</div>
</template>
<script>
	export default {
		name: "Garage",
		components: {},
		data() {
			return {
				ready: false
			};
		},
		computed: {
			garage() {
				return this.$store.state.garage;
			}
		},
		methods: {
			handleGarage(element, value) {
				this.ready = true;
				this.$store.commit("setGarage", value);
				var options = document.querySelectorAll(".option");
				var cible = document.getElementById(element);
				options.forEach(el => {
					el.classList.remove("selected");
				});
				cible.classList.add("selected");
			}
		},
		mounted() {
			this.$store.commit("setTimer", 60);
		}
	};
</script>

<style lang="less">
</style>